import styled from 'styled-components';
import { default as MuiClearIcon } from '@mui/icons-material/Clear';
import { Text } from 'shared/components';

export const Container = styled.div`
  width: 100%;
  padding: 10px;
  height: auto;
  overflow: auto;
  text-align: left !important;
`;

export const ClearIcon = styled(MuiClearIcon)`
  cursor: pointer;
  color: rgb(233, 30, 66);
`;

export const EmptyMsg = styled(Text)`
  padding-top: 160px;
`;
